<template>
  <v-container fluid>
    <v-layout xs12 column>
      <div v-for="(c, i) in contacts" :key="i">
        <ContactCard
          :name="c.name"
          :phoneNumbers="c.phoneNumbers"
          :url="c.url"
        />
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import ContactCard from "@/components/pages/Contact.vue";

export default {
  name: "SeairContactDialog",
  components: { ContactCard },
  data() {
    return {
      contacts: [
        {
          name: "Richmond (YVR)",
          phoneNumbers: ["1.800.447.3247", "1.604.273.8900"],
          url:
            "https://www.google.ca/maps/place/4640+Inglis+Dr,+Richmond,+BC/@49.1775739,-123.1726303,17z/data=!3m1!4b1!4m5!3m4!1s0x54860b27967ad95d:0x1d637cc5677a1425!8m2!3d49.1775739!4d-123.1704416"
        },
        {
          name: "Nanaimo",
          phoneNumbers: ["1.866.692.6440", "1.250.753.1115"],
          url:
            "https://www.google.ca/maps/place/Seair+Seaplanes+Ltd/@49.1908093,-123.9514439,17z/data=!4m13!1m7!3m6!1s0x5488a1770f16f2dd:0xab85aece7cf4d253!2s1956+Zorkin+Rd,+Nanaimo,+BC+V9S+5T9!3b1!8m2!3d49.1908058!4d-123.9492552!3m4!1s0x5488a17768afb18f:0x71ac8fd9c180a6fa!8m2!3d49.1907253!4d-123.9492208"
        },
        {
          name: "Vancouver Harbour",
          phoneNumbers: ["1.866.692.6440", "1.604.647.7575"],
          url:
            "https://www.google.ca/maps/dir//Vancouver+Harbour+Flight+Centre+Seaplane+Terminal+(CXH),+1055+Canada+Pl,+Vancouver,+BC+V6C+3T4/@49.2897156,-123.1182636,17z/data=!4m16!1m6!3m5!1s0x0:0xa0a6ce5a63e3bdc1!2sVancouver+Harbour+Flight+Centre+Seaplane+Terminal!8m2!3d49.2901741!4d-123.117578!4m8!1m0!1m5!1m1!1s0x5486718483cd58ff:0xa0a6ce5a63e3bdc1!2m2!1d-123.117578!2d49.290174!3e3"
        },
        {
          name: "Victoria Harbour",
          phoneNumbers: ["1.866.692.6440", "1.250.753.1115"],
          url:
            "https://www.google.ca/maps/dir//Harbour+Level,+1234+Wharf+St,+Victoria,+BC+V8W+3H9/@48.4265441,-123.4121981,13z/data=!3m1!4b1!4m9!4m8!1m0!1m5!1m1!1s0x548f749b0d816f6d:0x74bc6ad979416f51!2m2!1d-123.3709988!2d48.4265515!3e3?entry=ttu&g_ep=EgoyMDI1MDkyNC4wIKXMDSoASAFQAw%3D%3D"
        }
      ]
    };
  }
};
</script>
